import { render, staticRenderFns } from "./ReportTransfers.vue?vue&type=template&id=68ea0d46&scoped=true&"
import script from "./ReportTransfers.vue?vue&type=script&lang=js&"
export * from "./ReportTransfers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ea0d46",
  null
  
)

export default component.exports